export const SET_LOGGED_IN = 'SET_LOGGED_IN';
export const SET_VALIDATING_MESSAGE = 'SET_VALIDATING_MESSAGE';
export const SET_LOADING_MESSAGE = 'SET_LOADING_MESSAGE';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const SET_PUSH_TOKEN = 'SET_PUSH_TOKEN';
export const SET_INTERVAL_RELOAD_ID = 'SET_INTERVAL_RELOAD_ID';
